/**
 * Lightweight, dependency-free motion layer for the theme:
 * - [data-tilt] elements get a cursor-tracked 3D tilt (pointer devices only)
 * - .reveal / .reveal-stagger elements fade+rise into view on scroll
 * Respects prefers-reduced-motion by doing nothing.
 */
(function () {
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var canHover = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

  if (!reduceMotion && canHover) {
    // Event-delegated (not per-element) so [data-tilt] elements added after page load -
    // e.g. the PPF booking wizard's option buttons, rendered on the fly - get tilt too.
    var activeTilt = null;
    document.addEventListener('mousemove', function (e) {
      var el = e.target.closest ? e.target.closest('[data-tilt]') : null;
      if (el !== activeTilt) {
        if (activeTilt) activeTilt.style.transform = '';
        activeTilt = el;
        if (el) el.style.transformStyle = 'preserve-3d';
      }
      if (!el) return;
      var strength = parseFloat(el.getAttribute('data-tilt-strength')) || 8;
      var rect = el.getBoundingClientRect();
      var px = (e.clientX - rect.left) / rect.width - 0.5;
      var py = (e.clientY - rect.top) / rect.height - 0.5;
      el.style.transform =
        'perspective(1000px) rotateY(' + (px * strength).toFixed(2) + 'deg) ' +
        'rotateX(' + (-py * strength).toFixed(2) + 'deg) translateZ(0)';
    });
  }

  var revealEls = document.querySelectorAll('.reveal, .reveal-stagger');
  if (!revealEls.length) return;

  if (reduceMotion || !('IntersectionObserver' in window)) {
    revealEls.forEach(function (el) { el.classList.add('is-visible'); });
    return;
  }

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        io.unobserve(entry.target);
      }
    });
  }, { threshold: 0.15, rootMargin: '0px 0px -60px 0px' });

  revealEls.forEach(function (el) { io.observe(el); });
})();
